import {
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";
import { Eye, EyeClosed } from "lucide-react";
import { useEffect, useState } from "react";

export const MyInputBox = ({ icon, size, title, onChange, type, ...props }) => {
  const [passIcon, setPassIcon] = useState(Eye);
  const [inputType, setInputType] = useState({ type });
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    setInputType(type);
  }, []);

  const handleShowPassword = () => {
    if (inputType == "password") {
      setInputType("text");
      setPassIcon(EyeClosed);
    } else {
      setInputType("password");
      setPassIcon(Eye);
    }
  };
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <InputGroup>
      {icon && (
        <InputRightElement
          pointerEvents="none"
          borderLeftColor="gray.200"
          borderLeftWidth={1}
        >
          <Icon
            as={icon}
            textColor={focused ? "orange" : ""}
            pointerEvents="none"
            color="gray.500"
          />
        </InputRightElement>
      )}
      <Input
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        fontFamily="iransans"
        type={inputType}
        pr={icon ? "2.9rem" : 1}
        pl={type == "password" ? "2.9rem" : 1}
        placeholder={title}
        htmlSize={type == "password" ? size - 3 : size}
        onChange={handleChange}
        {...props}
      />
      {type == "password" && (
        <InputLeftElement
          onClick={handleShowPassword}
          _hover={{ color: "orange", cursor: "pointer" }}
        >
          <Icon as={passIcon} />
        </InputLeftElement>
      )}
    </InputGroup>
  );
};
